import { render, staticRenderFns } from "./FutureAddressFloorLevelField.vue?vue&type=template&id=96fc880a"
import script from "./FutureAddressFloorLevelField.vue?vue&type=script&lang=js"
export * from "./FutureAddressFloorLevelField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports